import GridContainer from "./GridContainer";

## Basic Usage

The GridContainer provides a responsive grid layout wrapper.

<GridContainer>
  <div style={{ background: "#e5e5e5", padding: "1rem", borderRadius: "4px" }}>Item 1</div>
  <div style={{ background: "#e5e5e5", padding: "1rem", borderRadius: "4px" }}>Item 2</div>
  <div style={{ background: "#e5e5e5", padding: "1rem", borderRadius: "4px" }}>Item 3</div>
  <div style={{ background: "#e5e5e5", padding: "1rem", borderRadius: "4px" }}>Item 4</div>
</GridContainer>

---

## Card Grid

<GridContainer>
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ margin: "0 0 0.5rem" }}>Card 1</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Description text</p>
  </div>
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ margin: "0 0 0.5rem" }}>Card 2</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Description text</p>
  </div>
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ margin: "0 0 0.5rem" }}>Card 3</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Description text</p>
  </div>
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ margin: "0 0 0.5rem" }}>Card 4</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Description text</p>
  </div>
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ margin: "0 0 0.5rem" }}>Card 5</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Description text</p>
  </div>
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ margin: "0 0 0.5rem" }}>Card 6</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Description text</p>
  </div>
</GridContainer>

---

## Feature Grid

<GridContainer>
  <div style={{ textAlign: "center", padding: "1.5rem" }}>
    <div style={{ fontSize: "32px", marginBottom: "0.5rem" }}>1</div>
    <h4 style={{ margin: "0 0 0.25rem" }}>Feature One</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Brief description of feature</p>
  </div>
  <div style={{ textAlign: "center", padding: "1.5rem" }}>
    <div style={{ fontSize: "32px", marginBottom: "0.5rem" }}>2</div>
    <h4 style={{ margin: "0 0 0.25rem" }}>Feature Two</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Brief description of feature</p>
  </div>
  <div style={{ textAlign: "center", padding: "1.5rem" }}>
    <div style={{ fontSize: "32px", marginBottom: "0.5rem" }}>3</div>
    <h4 style={{ margin: "0 0 0.25rem" }}>Feature Three</h4>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Brief description of feature</p>
  </div>
</GridContainer>

---

## Image Gallery

<GridContainer>
  <div style={{ background: "#f0f0f0", paddingBottom: "100%", borderRadius: "4px" }} />
  <div style={{ background: "#e0e0e0", paddingBottom: "100%", borderRadius: "4px" }} />
  <div style={{ background: "#d0d0d0", paddingBottom: "100%", borderRadius: "4px" }} />
  <div style={{ background: "#c0c0c0", paddingBottom: "100%", borderRadius: "4px" }} />
</GridContainer>


